export default __webpack_public_path__ + "static/media/SP_Logo_blok_cir.da1ee977.jpg";